module.exports = "<div class=\"mbgf-col-sm-12 input-box text-field\" data-module=\"input\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./js-src/markdown-editor/modules/input/input.html
// module id = 105
// module chunks = 0 1